import { AnyAction } from 'redux';
import {
  CART_ADD_TO_CART_ANIMATION,
  CART_RECEIVE,
  CART_SHOW_MINI_CART,
  CART_LOAD_ERROR
} from '../constants';
import { OrderRow } from '../Types/OrderRow';
import { error as errorReducer } from './Error.reducer';
import { EditorStringModel } from '../Types/EditorString';

interface UspModel {
  title: string;
  description: EditorStringModel;
  icon: string;
  alt: string;
}

export interface CartState {
  quantity: number;
  orderTotal: number;
  gtmGrandTotal: number;
  showMiniCart: boolean;
  addToCartAnimating: boolean;
  orderRows: OrderRow[];
  emptyCartLink?: string;
  emptyCartText?: string;
  emptyCartUsps?: UspModel[];
  checkoutUrl?: string;
  discount?: string;
  deliveryCost?: string;
  paymentCost?: string;
  grandTotal?: string;
  vat?: string;
  errors: any;
  expressCheckoutEnabled: boolean;
}

const DEFAULT_STATE: CartState = {
  quantity: 0,
  orderTotal: 0,
  gtmGrandTotal: 0,
  showMiniCart: false,
  addToCartAnimating: false,
  orderRows: [],
  errors: {},
  expressCheckoutEnabled: false
};

export const cart = (state = DEFAULT_STATE, action: AnyAction): CartState => {
  switch (action.type) {
    case CART_LOAD_ERROR:
    case CART_RECEIVE:
      return {
        ...state,
        ...action.payload,
        errors: errorReducer(state.errors, action),
      };
    case CART_SHOW_MINI_CART:
    case CART_ADD_TO_CART_ANIMATION:
      return {
        ...state,
        ...action.payload,
          errors: errorReducer(state.errors, action),

      };
    default:
      return state;
  }
};
